import PropTypes from 'prop-types';
import React from 'react';

import { DorUnits, DorUnitsDisplay, Symbols } from '@powdr/constants';
import { useCurrentSnowfall, useCurrentTemperature } from '@powdr/hooks';
import { checkIfNullUndefined } from '@powdr/utils';
import { useStaticData } from '@powdr/web/src/hooks';

import {
  SnowfallIcon,
  SnowfallInfo,
  StyledDorToggle,
  TempIcon,
  TemperatureInfo,
  IndicatorIcon,
  IndicatorWrapper,
  SnowfallText,
  SnowfallUnit,
} from './styles';

export const DorToggle = ({
  onClick,
}) => {
  const { headerConfig } = useStaticData();
  const temperatureData = useCurrentTemperature();
  const snowfallData = useCurrentSnowfall();

  return (
    <StyledDorToggle
      id="open-dor-information-drawer" // do not change, needed for tracking
      title="Open DOR Information Drawer"
      onClick={onClick}
      $isInfoHidden={!headerConfig?.feedSnowfallHide || !headerConfig?.feedTempHide}
    >
      {(!headerConfig?.feedSnowfallHide) && (
        <SnowfallInfo>
          <SnowfallIcon name="dor-snow" />
          {(snowfallData.unit !== DorUnitsDisplay[DorUnits.CENTIMETERS]) ? (
            `${(!snowfallData || snowfallData?.value === null) ? Symbols.DOUBLE_DASH : snowfallData.value}${snowfallData.unit}`
          ) : (
            <SnowfallText>
              {`${(!snowfallData || snowfallData?.value === null) ? Symbols.DOUBLE_DASH : snowfallData.value}`}
              <SnowfallUnit>
                {snowfallData.unit}
              </SnowfallUnit>
            </SnowfallText>
          )}
        </SnowfallInfo>
      )}
      {(!headerConfig?.feedTempHide) && (
        <TemperatureInfo>
          <TempIcon name={temperatureData?.icon} />
          {`${(checkIfNullUndefined(temperatureData?.value)) ? Symbols.DOUBLE_DASH : Math.round(temperatureData.value)}${Symbols.DEGREE}`}
        </TemperatureInfo>
      )}
      <IndicatorWrapper>
        <IndicatorIcon name="ui-arrow-down" />
      </IndicatorWrapper>
    </StyledDorToggle>
  );
};

DorToggle.propTypes = {
  onClick: PropTypes.func.isRequired,
};
